import React, { useEffect, useState } from "react";
import { Card } from "antd";
import { GET_API } from "../../Functionalities/APIs";
import { homeFeedUrl, surplusBannersUrl } from "../../Constants/apiUrls";
import { previewBlocks } from "./previewBlocks";
import BannerStrip from "./preview/BannerStrip";
import { INK } from "./preview/look";
import { Restaurants, ViewAllButton } from "./preview/Restaurants";
import SaleHero from "./preview/SaleHero";
import ScreenTop from "./preview/ScreenTop";
import SquareSections from "./preview/SquareSections";

const DRAW = { strip: BannerStrip, saleHero: SaleHero, sections: SquareSections, restaurants: Restaurants, viewAll: ViewAllButton };

const phone = {
  width: 380, maxWidth: "100%", height: 760, margin: "0 auto", borderRadius: 36, border: "10px solid #1f1f1f",
  background: "#fff", overflowY: "auto", overflowX: "hidden", padding: "8px 0 16px",
  fontFamily: '"Poppins", sans-serif', color: INK,
};

const ring = (on) => (on ? { outline: "3px solid #fb310d", outlineOffset: -3, borderRadius: 8 } : {});

const Note = ({ children }) => <div className="text-center text-muted mt-5 px-3">{children}</div>;

function useScreenReply(franchise, screen, version) {
  const [reply, setReply] = useState(null);
  const latitude = franchise && franchise.latitude;
  const longitude = franchise && franchise.longitude;
  useEffect(() => {
    if (latitude == null || longitude == null) return undefined;
    let current = true;
    GET_API("", `latitude=${latitude}&longitude=${longitude}`, screen === "surplus" ? surplusBannersUrl : homeFeedUrl)
      .then((result) => current && setReply(result && result.data && result.data.Status === true ? result.data : null))
      .catch(() => current && setReply(null));
    return () => {
      current = false;
    };
  }, [latitude, longitude, screen, version]);
  return latitude == null || longitude == null ? { located: false, reply: null } : { located: true, reply };
}

function Screen({ franchise, screen, highlightPlacement, version }) {
  const { located, reply } = useScreenReply(franchise, screen, version);
  if (!located) return <Note>Set this franchise's location to see the preview</Note>;
  if (!reply) return null;
  const blocks = previewBlocks(reply, screen, highlightPlacement);
  return (
    <>
      <ScreenTop screen={screen} franchise={franchise} />
      {!blocks.length && <Note>Nothing shows here yet for this location</Note>}
      {blocks.map((block) => {
        const Draw = DRAW[block.kind];
        return (
          <div key={`${block.kind}-${block.placement || block.title}`} style={ring(block.highlighted)}>
            <Draw block={block} />
          </div>
        );
      })}
    </>
  );
}

export default function PhonePreview({ franchise, screen, highlightPlacement, version }) {
  return (
    <Card title="Phone preview" size="small">
      <div className="text-muted mb-2" style={{ fontSize: 12 }}>
        What a customer standing at {franchise && franchise.name ? `${franchise.name}'s` : "the franchise's"} centre sees.
        Banners from nearby franchises show too.
      </div>
      <div style={phone}>
        {franchise && <Screen franchise={franchise} screen={screen} highlightPlacement={highlightPlacement} version={version} />}
      </div>
    </Card>
  );
}
